export default "__VITE_ASSET__Hyu3VyYx__"